import { ReactNode, createContext } from "react";
import useContratoStatusReport, {
    ContratoStatusReportType,
    ContratoStatusReportFilters,
} from "./hooks/useContratoStatusReport";

interface ContratoStatusReportContextProviderProps {
    children: ReactNode;
}

export interface ContratoStatusReportContextData {
    listContratoStatusReport: ContratoStatusReportType[];
    contratoStatusReportPageCount: number;
    setListContratoStatusReport: (list: ContratoStatusReportType[]) => void;
    setContratoStatusReportPageCount: (count: number) => void;
    getContratoStatusReportPaged: (
        pageNumber: number,
        pageSize: number,
        filters: ContratoStatusReportFilters
    ) => Promise<ContratoStatusReportType[] | null>;
    exportContratoStatusReportPdf: (filters: ContratoStatusReportFilters) => Promise<void>;
}

const initialState: ContratoStatusReportContextData = {
    listContratoStatusReport: [],
    contratoStatusReportPageCount: 0,
    setListContratoStatusReport: () => { },
    setContratoStatusReportPageCount: () => { },
    getContratoStatusReportPaged: async () => null,
    exportContratoStatusReportPdf: async () => { },
};

export const ContratoStatusReportContext =
    createContext<ContratoStatusReportContextData>(initialState);

export default function ContratoStatusReportContextProvider({
    children,
}: ContratoStatusReportContextProviderProps) {
    const {
        listContratoStatusReport,
        contratoStatusReportPageCount,
        setListContratoStatusReport,
        setContratoStatusReportPageCount,
        getContratoStatusReportPaged,
        exportContratoStatusReportPdf,
    } = useContratoStatusReport();

    return (
        <ContratoStatusReportContext.Provider
            value={{
                listContratoStatusReport,
                contratoStatusReportPageCount,
                setListContratoStatusReport,
                setContratoStatusReportPageCount,
                getContratoStatusReportPaged,
                exportContratoStatusReportPdf,
            }}
        >
            {children}
        </ContratoStatusReportContext.Provider>
    );
}
